/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as DisplayRouteImport } from './routes/display'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAffiliationsRouteImport } from './routes/_authenticated/affiliations'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedEntriesRouteImport } from './routes/_authenticated/entries'
import { Route as AuthenticatedFeedbackRouteImport } from './routes/_authenticated/feedback'
import { Route as AuthenticatedLiveMapRouteImport } from './routes/_authenticated/live-map'
import { Route as AuthenticatedOrdersRouteImport } from './routes/_authenticated/orders'
import { Route as AuthenticatedPracticeMapRouteImport } from './routes/_authenticated/practice-map'
import { Route as AuthenticatedPracticesRouteImport } from './routes/_authenticated/practices'
import { Route as AuthenticatedProvidersRouteImport } from './routes/_authenticated/providers'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedTotalValuePlannerRouteImport } from './routes/_authenticated/total-value-planner'
import { Route as AuthenticatedWhatsNewRouteImport } from './routes/_authenticated/whats-new'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as DisplayLiveMapRouteImport } from './routes/display/live-map'
import { Route as AuthenticatedAccountsAffiliationIdRouteImport } from './routes/_authenticated/accounts.$affiliationId'
import { Route as AuthenticatedAffiliationsAffiliationIdRouteImport } from './routes/_authenticated/affiliations_.$affiliationId'
import { Route as AuthenticatedEntriesEntryIdRouteImport } from './routes/_authenticated/entries_.$entryId'
import { Route as AuthenticatedEntriesNewRouteImport } from './routes/_authenticated/entries_.new'
import { Route as AuthenticatedOrdersOrderIdRouteImport } from './routes/_authenticated/orders_.$orderId'
import { Route as AuthenticatedOrdersNewRouteImport } from './routes/_authenticated/orders_.new'
import { Route as AuthenticatedPracticesPracticeIdRouteImport } from './routes/_authenticated/practices_.$practiceId'
import { Route as AuthenticatedPracticesCreateRouteImport } from './routes/_authenticated/practices_.create'
import { Route as AuthenticatedProvidersNewRouteImport } from './routes/_authenticated/providers_.new'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports.index'
import { Route as AuthenticatedReportsQuarterlyRouteImport } from './routes/_authenticated/reports.quarterly'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSettingsSectionRouteImport } from './routes/_authenticated/settings.$section'
import { Route as AuthenticatedPracticesPracticeIdEditRouteImport } from './routes/_authenticated/practices_.$practiceId_.edit'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayRoute = DisplayRouteImport.update({
  id: '/display',
  path: '/display',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAffiliationsRoute =
  AuthenticatedAffiliationsRouteImport.update({
    id: '/affiliations',
    path: '/affiliations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEntriesRoute = AuthenticatedEntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedbackRoute = AuthenticatedFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLiveMapRoute = AuthenticatedLiveMapRouteImport.update({
  id: '/live-map',
  path: '/live-map',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrdersRoute = AuthenticatedOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPracticeMapRoute =
  AuthenticatedPracticeMapRouteImport.update({
    id: '/practice-map',
    path: '/practice-map',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPracticesRoute = AuthenticatedPracticesRouteImport.update({
  id: '/practices',
  path: '/practices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProvidersRoute = AuthenticatedProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTotalValuePlannerRoute =
  AuthenticatedTotalValuePlannerRouteImport.update({
    id: '/total-value-planner',
    path: '/total-value-planner',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWhatsNewRoute = AuthenticatedWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayLiveMapRoute = DisplayLiveMapRouteImport.update({
  id: '/live-map',
  path: '/live-map',
  getParentRoute: () => DisplayRoute,
} as any)
const AuthenticatedAccountsAffiliationIdRoute =
  AuthenticatedAccountsAffiliationIdRouteImport.update({
    id: '/accounts/$affiliationId',
    path: '/accounts/$affiliationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAffiliationsAffiliationIdRoute =
  AuthenticatedAffiliationsAffiliationIdRouteImport.update({
    id: '/affiliations_/$affiliationId',
    path: '/affiliations/$affiliationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntriesEntryIdRoute =
  AuthenticatedEntriesEntryIdRouteImport.update({
    id: '/entries_/$entryId',
    path: '/entries/$entryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntriesNewRoute = AuthenticatedEntriesNewRouteImport.update({
  id: '/entries_/new',
  path: '/entries/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: '/orders_/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersNewRoute = AuthenticatedOrdersNewRouteImport.update({
  id: '/orders_/new',
  path: '/orders/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPracticesPracticeIdRoute =
  AuthenticatedPracticesPracticeIdRouteImport.update({
    id: '/practices_/$practiceId',
    path: '/practices/$practiceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPracticesCreateRoute =
  AuthenticatedPracticesCreateRouteImport.update({
    id: '/practices_/create',
    path: '/practices/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProvidersNewRoute =
  AuthenticatedProvidersNewRouteImport.update({
    id: '/providers_/new',
    path: '/providers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsQuarterlyRoute =
  AuthenticatedReportsQuarterlyRouteImport.update({
    id: '/quarterly',
    path: '/quarterly',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSectionRoute =
  AuthenticatedSettingsSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedPracticesPracticeIdEditRoute =
  AuthenticatedPracticesPracticeIdEditRouteImport.update({
    id: '/practices_/$practiceId_/edit',
    path: '/practices/$practiceId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/display': typeof DisplayRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/affiliations': typeof AuthenticatedAffiliationsRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/entries': typeof AuthenticatedEntriesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/live-map': typeof AuthenticatedLiveMapRoute
  '/orders': typeof AuthenticatedOrdersRoute
  '/practice-map': typeof AuthenticatedPracticeMapRoute
  '/practices': typeof AuthenticatedPracticesRoute
  '/providers': typeof AuthenticatedProvidersRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/total-value-planner': typeof AuthenticatedTotalValuePlannerRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/display/live-map': typeof DisplayLiveMapRoute
  '/accounts/$affiliationId': typeof AuthenticatedAccountsAffiliationIdRoute
  '/affiliations/$affiliationId': typeof AuthenticatedAffiliationsAffiliationIdRoute
  '/entries/$entryId': typeof AuthenticatedEntriesEntryIdRoute
  '/entries/new': typeof AuthenticatedEntriesNewRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/new': typeof AuthenticatedOrdersNewRoute
  '/practices/$practiceId': typeof AuthenticatedPracticesPracticeIdRoute
  '/practices/create': typeof AuthenticatedPracticesCreateRoute
  '/providers/new': typeof AuthenticatedProvidersNewRoute
  '/reports/quarterly': typeof AuthenticatedReportsQuarterlyRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/practices/$practiceId/edit': typeof AuthenticatedPracticesPracticeIdEditRoute
}
export interface FileRoutesByTo {
  '/display': typeof DisplayRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/affiliations': typeof AuthenticatedAffiliationsRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/entries': typeof AuthenticatedEntriesRoute
  '/feedback': typeof AuthenticatedFeedbackRoute
  '/live-map': typeof AuthenticatedLiveMapRoute
  '/orders': typeof AuthenticatedOrdersRoute
  '/practice-map': typeof AuthenticatedPracticeMapRoute
  '/practices': typeof AuthenticatedPracticesRoute
  '/providers': typeof AuthenticatedProvidersRoute
  '/total-value-planner': typeof AuthenticatedTotalValuePlannerRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/display/live-map': typeof DisplayLiveMapRoute
  '/': typeof AuthenticatedIndexRoute
  '/accounts/$affiliationId': typeof AuthenticatedAccountsAffiliationIdRoute
  '/affiliations/$affiliationId': typeof AuthenticatedAffiliationsAffiliationIdRoute
  '/entries/$entryId': typeof AuthenticatedEntriesEntryIdRoute
  '/entries/new': typeof AuthenticatedEntriesNewRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/orders/new': typeof AuthenticatedOrdersNewRoute
  '/practices/$practiceId': typeof AuthenticatedPracticesPracticeIdRoute
  '/practices/create': typeof AuthenticatedPracticesCreateRoute
  '/providers/new': typeof AuthenticatedProvidersNewRoute
  '/reports/quarterly': typeof AuthenticatedReportsQuarterlyRoute
  '/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/practices/$practiceId/edit': typeof AuthenticatedPracticesPracticeIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/display': typeof DisplayRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/_authenticated/affiliations': typeof AuthenticatedAffiliationsRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/entries': typeof AuthenticatedEntriesRoute
  '/_authenticated/feedback': typeof AuthenticatedFeedbackRoute
  '/_authenticated/live-map': typeof AuthenticatedLiveMapRoute
  '/_authenticated/orders': typeof AuthenticatedOrdersRoute
  '/_authenticated/practice-map': typeof AuthenticatedPracticeMapRoute
  '/_authenticated/practices': typeof AuthenticatedPracticesRoute
  '/_authenticated/providers': typeof AuthenticatedProvidersRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/total-value-planner': typeof AuthenticatedTotalValuePlannerRoute
  '/_authenticated/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/display/live-map': typeof DisplayLiveMapRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/accounts/$affiliationId': typeof AuthenticatedAccountsAffiliationIdRoute
  '/_authenticated/affiliations_/$affiliationId': typeof AuthenticatedAffiliationsAffiliationIdRoute
  '/_authenticated/entries_/$entryId': typeof AuthenticatedEntriesEntryIdRoute
  '/_authenticated/entries_/new': typeof AuthenticatedEntriesNewRoute
  '/_authenticated/orders_/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/_authenticated/orders_/new': typeof AuthenticatedOrdersNewRoute
  '/_authenticated/practices_/$practiceId': typeof AuthenticatedPracticesPracticeIdRoute
  '/_authenticated/practices_/create': typeof AuthenticatedPracticesCreateRoute
  '/_authenticated/providers_/new': typeof AuthenticatedProvidersNewRoute
  '/_authenticated/reports/quarterly': typeof AuthenticatedReportsQuarterlyRoute
  '/_authenticated/settings/$section': typeof AuthenticatedSettingsSectionRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/practices_/$practiceId_/edit': typeof AuthenticatedPracticesPracticeIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/display'
    | '/login'
    | '/privacy'
    | '/affiliations'
    | '/calendar'
    | '/dashboard'
    | '/entries'
    | '/feedback'
    | '/live-map'
    | '/orders'
    | '/practice-map'
    | '/practices'
    | '/providers'
    | '/reports'
    | '/settings'
    | '/total-value-planner'
    | '/whats-new'
    | '/auth/callback'
    | '/display/live-map'
    | '/accounts/$affiliationId'
    | '/affiliations/$affiliationId'
    | '/entries/$entryId'
    | '/entries/new'
    | '/orders/$orderId'
    | '/orders/new'
    | '/practices/$practiceId'
    | '/practices/create'
    | '/providers/new'
    | '/reports/quarterly'
    | '/settings/$section'
    | '/reports/'
    | '/settings/'
    | '/practices/$practiceId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/display'
    | '/login'
    | '/privacy'
    | '/affiliations'
    | '/calendar'
    | '/dashboard'
    | '/entries'
    | '/feedback'
    | '/live-map'
    | '/orders'
    | '/practice-map'
    | '/practices'
    | '/providers'
    | '/total-value-planner'
    | '/whats-new'
    | '/auth/callback'
    | '/display/live-map'
    | '/'
    | '/accounts/$affiliationId'
    | '/affiliations/$affiliationId'
    | '/entries/$entryId'
    | '/entries/new'
    | '/orders/$orderId'
    | '/orders/new'
    | '/practices/$practiceId'
    | '/practices/create'
    | '/providers/new'
    | '/reports/quarterly'
    | '/settings/$section'
    | '/reports'
    | '/settings'
    | '/practices/$practiceId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/display'
    | '/login'
    | '/privacy'
    | '/_authenticated/affiliations'
    | '/_authenticated/calendar'
    | '/_authenticated/dashboard'
    | '/_authenticated/entries'
    | '/_authenticated/feedback'
    | '/_authenticated/live-map'
    | '/_authenticated/orders'
    | '/_authenticated/practice-map'
    | '/_authenticated/practices'
    | '/_authenticated/providers'
    | '/_authenticated/reports'
    | '/_authenticated/settings'
    | '/_authenticated/total-value-planner'
    | '/_authenticated/whats-new'
    | '/auth/callback'
    | '/display/live-map'
    | '/_authenticated/'
    | '/_authenticated/accounts/$affiliationId'
    | '/_authenticated/affiliations_/$affiliationId'
    | '/_authenticated/entries_/$entryId'
    | '/_authenticated/entries_/new'
    | '/_authenticated/orders_/$orderId'
    | '/_authenticated/orders_/new'
    | '/_authenticated/practices_/$practiceId'
    | '/_authenticated/practices_/create'
    | '/_authenticated/providers_/new'
    | '/_authenticated/reports/quarterly'
    | '/_authenticated/settings/$section'
    | '/_authenticated/reports/'
    | '/_authenticated/settings/'
    | '/_authenticated/practices_/$practiceId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  DisplayRoute: typeof DisplayRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display': {
      id: '/display'
      path: '/display'
      fullPath: '/display'
      preLoaderRoute: typeof DisplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/affiliations': {
      id: '/_authenticated/affiliations'
      path: '/affiliations'
      fullPath: '/affiliations'
      preLoaderRoute: typeof AuthenticatedAffiliationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entries': {
      id: '/_authenticated/entries'
      path: '/entries'
      fullPath: '/entries'
      preLoaderRoute: typeof AuthenticatedEntriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feedback': {
      id: '/_authenticated/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AuthenticatedFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-map': {
      id: '/_authenticated/live-map'
      path: '/live-map'
      fullPath: '/live-map'
      preLoaderRoute: typeof AuthenticatedLiveMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders': {
      id: '/_authenticated/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practice-map': {
      id: '/_authenticated/practice-map'
      path: '/practice-map'
      fullPath: '/practice-map'
      preLoaderRoute: typeof AuthenticatedPracticeMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practices': {
      id: '/_authenticated/practices'
      path: '/practices'
      fullPath: '/practices'
      preLoaderRoute: typeof AuthenticatedPracticesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/providers': {
      id: '/_authenticated/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof AuthenticatedProvidersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/total-value-planner': {
      id: '/_authenticated/total-value-planner'
      path: '/total-value-planner'
      fullPath: '/total-value-planner'
      preLoaderRoute: typeof AuthenticatedTotalValuePlannerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/whats-new': {
      id: '/_authenticated/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AuthenticatedWhatsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display/live-map': {
      id: '/display/live-map'
      path: '/live-map'
      fullPath: '/display/live-map'
      preLoaderRoute: typeof DisplayLiveMapRouteImport
      parentRoute: typeof DisplayRoute
    }
    '/_authenticated/accounts/$affiliationId': {
      id: '/_authenticated/accounts/$affiliationId'
      path: '/accounts/$affiliationId'
      fullPath: '/accounts/$affiliationId'
      preLoaderRoute: typeof AuthenticatedAccountsAffiliationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/affiliations_/$affiliationId': {
      id: '/_authenticated/affiliations_/$affiliationId'
      path: '/affiliations/$affiliationId'
      fullPath: '/affiliations/$affiliationId'
      preLoaderRoute: typeof AuthenticatedAffiliationsAffiliationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entries_/$entryId': {
      id: '/_authenticated/entries_/$entryId'
      path: '/entries/$entryId'
      fullPath: '/entries/$entryId'
      preLoaderRoute: typeof AuthenticatedEntriesEntryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entries_/new': {
      id: '/_authenticated/entries_/new'
      path: '/entries/new'
      fullPath: '/entries/new'
      preLoaderRoute: typeof AuthenticatedEntriesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders_/$orderId': {
      id: '/_authenticated/orders_/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders_/new': {
      id: '/_authenticated/orders_/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AuthenticatedOrdersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practices_/$practiceId': {
      id: '/_authenticated/practices_/$practiceId'
      path: '/practices/$practiceId'
      fullPath: '/practices/$practiceId'
      preLoaderRoute: typeof AuthenticatedPracticesPracticeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practices_/create': {
      id: '/_authenticated/practices_/create'
      path: '/practices/create'
      fullPath: '/practices/create'
      preLoaderRoute: typeof AuthenticatedPracticesCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/providers_/new': {
      id: '/_authenticated/providers_/new'
      path: '/providers/new'
      fullPath: '/providers/new'
      preLoaderRoute: typeof AuthenticatedProvidersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/quarterly': {
      id: '/_authenticated/reports/quarterly'
      path: '/quarterly'
      fullPath: '/reports/quarterly'
      preLoaderRoute: typeof AuthenticatedReportsQuarterlyRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/$section': {
      id: '/_authenticated/settings/$section'
      path: '/$section'
      fullPath: '/settings/$section'
      preLoaderRoute: typeof AuthenticatedSettingsSectionRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/practices_/$practiceId_/edit': {
      id: '/_authenticated/practices_/$practiceId_/edit'
      path: '/practices/$practiceId/edit'
      fullPath: '/practices/$practiceId/edit'
      preLoaderRoute: typeof AuthenticatedPracticesPracticeIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsQuarterlyRoute: typeof AuthenticatedReportsQuarterlyRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsQuarterlyRoute: AuthenticatedReportsQuarterlyRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsSectionRoute: typeof AuthenticatedSettingsSectionRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsSectionRoute: AuthenticatedSettingsSectionRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAffiliationsRoute: typeof AuthenticatedAffiliationsRoute
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEntriesRoute: typeof AuthenticatedEntriesRoute
  AuthenticatedFeedbackRoute: typeof AuthenticatedFeedbackRoute
  AuthenticatedLiveMapRoute: typeof AuthenticatedLiveMapRoute
  AuthenticatedOrdersRoute: typeof AuthenticatedOrdersRoute
  AuthenticatedPracticeMapRoute: typeof AuthenticatedPracticeMapRoute
  AuthenticatedPracticesRoute: typeof AuthenticatedPracticesRoute
  AuthenticatedProvidersRoute: typeof AuthenticatedProvidersRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedTotalValuePlannerRoute: typeof AuthenticatedTotalValuePlannerRoute
  AuthenticatedWhatsNewRoute: typeof AuthenticatedWhatsNewRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountsAffiliationIdRoute: typeof AuthenticatedAccountsAffiliationIdRoute
  AuthenticatedAffiliationsAffiliationIdRoute: typeof AuthenticatedAffiliationsAffiliationIdRoute
  AuthenticatedEntriesEntryIdRoute: typeof AuthenticatedEntriesEntryIdRoute
  AuthenticatedEntriesNewRoute: typeof AuthenticatedEntriesNewRoute
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute
  AuthenticatedOrdersNewRoute: typeof AuthenticatedOrdersNewRoute
  AuthenticatedPracticesPracticeIdRoute: typeof AuthenticatedPracticesPracticeIdRoute
  AuthenticatedPracticesCreateRoute: typeof AuthenticatedPracticesCreateRoute
  AuthenticatedProvidersNewRoute: typeof AuthenticatedProvidersNewRoute
  AuthenticatedPracticesPracticeIdEditRoute: typeof AuthenticatedPracticesPracticeIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAffiliationsRoute: AuthenticatedAffiliationsRoute,
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEntriesRoute: AuthenticatedEntriesRoute,
  AuthenticatedFeedbackRoute: AuthenticatedFeedbackRoute,
  AuthenticatedLiveMapRoute: AuthenticatedLiveMapRoute,
  AuthenticatedOrdersRoute: AuthenticatedOrdersRoute,
  AuthenticatedPracticeMapRoute: AuthenticatedPracticeMapRoute,
  AuthenticatedPracticesRoute: AuthenticatedPracticesRoute,
  AuthenticatedProvidersRoute: AuthenticatedProvidersRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedTotalValuePlannerRoute: AuthenticatedTotalValuePlannerRoute,
  AuthenticatedWhatsNewRoute: AuthenticatedWhatsNewRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountsAffiliationIdRoute:
    AuthenticatedAccountsAffiliationIdRoute,
  AuthenticatedAffiliationsAffiliationIdRoute:
    AuthenticatedAffiliationsAffiliationIdRoute,
  AuthenticatedEntriesEntryIdRoute: AuthenticatedEntriesEntryIdRoute,
  AuthenticatedEntriesNewRoute: AuthenticatedEntriesNewRoute,
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedOrdersNewRoute: AuthenticatedOrdersNewRoute,
  AuthenticatedPracticesPracticeIdRoute: AuthenticatedPracticesPracticeIdRoute,
  AuthenticatedPracticesCreateRoute: AuthenticatedPracticesCreateRoute,
  AuthenticatedProvidersNewRoute: AuthenticatedProvidersNewRoute,
  AuthenticatedPracticesPracticeIdEditRoute:
    AuthenticatedPracticesPracticeIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface DisplayRouteChildren {
  DisplayLiveMapRoute: typeof DisplayLiveMapRoute
}

const DisplayRouteChildren: DisplayRouteChildren = {
  DisplayLiveMapRoute: DisplayLiveMapRoute,
}

const DisplayRouteWithChildren =
  DisplayRoute._addFileChildren(DisplayRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  DisplayRoute: DisplayRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
